import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const LABELS_4 = ['Ton déclic', 'Cette formation', 'Ce que tu apportes', 'Tes projets'];
const LABELS_5 = ['Ton déclic', 'Cette formation', 'Ton parcours', 'Le lien', 'Tes projets'];

function getLabel(fragmentId, split3b) {
  if (fragmentId === 'FRAGMENT_3B') return 'Le lien';
  const num = parseInt(fragmentId.replace('FRAGMENT_', ''), 10) - 1;
  return (split3b ? LABELS_5 : LABELS_4)[num] ?? fragmentId;
}

/**
 * @param {{ fragmentId: string, fragmentText: string, split3b: boolean }} props
 */
export default function TivFragment({ fragmentId, fragmentText, split3b }) {
  const [copied, setCopied] = useState(false);
  const partNum = fragmentId.replace('FRAGMENT_', '');
  const label   = getLabel(fragmentId, split3b);

  function handleCopy() {
    navigator.clipboard.writeText(fragmentText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="relative bg-gradient-to-br from-emerald-500/[0.08] to-emerald-500/[0.03] border border-emerald-500/20 rounded-2xl rounded-tl-sm px-4 pt-3 pb-4">
      <div className="flex items-start justify-between gap-3 mb-2">
        <span className="text-[10px] font-bold text-emerald-400 uppercase tracking-wider leading-tight">
          ✦ Partie {partNum} – {label}
        </span>
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-[10px] text-zinc-500">{fragmentText.length} car.</span>
          <button
            onClick={handleCopy}
            className="p-1 rounded-md hover:bg-white/[0.06] transition-colors text-zinc-400 hover:text-zinc-200"
            title="Copier"
          >
            {copied
              ? <Check size={12} className="text-emerald-400" />
              : <Copy size={12} />
            }
          </button>
        </div>
      </div>
      <p className="text-sm leading-relaxed italic text-zinc-300 whitespace-pre-wrap">
        {fragmentText}
      </p>
    </div>
  );
}
